import { gql } from "@apollo/client";

const BOOKING_FIELDS = `
  id
  eventId
  userId
  customerName
  customerEmail
  customerPhone
  horseIds
  startTime
  endTime
  status
  notes
  depositAmount
  depositPaidAt
  stripeSessionId
  stripePaymentIntentId
  checkedInAt
  completedAt
  scanAmount
  balanceDue
  balancePaidAt
  balancePaymentIntentId
  invoiceId
  invoiceHostedUrl
  createdAt
  updatedAt
`;

export const CREATE_BOOKING_BALANCE_CHECKOUT = gql`
  mutation createBookingBalanceCheckout($id: ID!) {
    createBookingBalanceCheckout(id: $id)
  }
`;

export const SEND_BOOKING_INVOICE = gql`
  mutation sendBookingInvoice($id: ID!) {
    sendBookingInvoice(id: $id) { ${BOOKING_FIELDS} }
  }
`;

export const CREATE_BOOKING = gql`
  mutation createBooking($input: CreateBookingInput!) {
    createBooking(input: $input) {
      checkoutUrl
      booking { ${BOOKING_FIELDS} }
    }
  }
`;

export const UPDATE_BOOKING = gql`
  mutation updateBooking($id: ID!, $input: UpdateBookingInput!) {
    updateBooking(id: $id, input: $input) { ${BOOKING_FIELDS} }
  }
`;

export const CANCEL_BOOKING = gql`
  mutation cancelBooking($id: ID!) {
    cancelBooking(id: $id) { ${BOOKING_FIELDS} }
  }
`;

export const REFUND_BOOKING_DEPOSIT = gql`
  mutation refundBookingDeposit($id: ID!) {
    refundBookingDeposit(id: $id) { ${BOOKING_FIELDS} }
  }
`;

export const RESET_CUSTOMER_NO_SHOW_COUNT = gql`
  mutation resetCustomerNoShowCount($userId: ID!) {
    resetCustomerNoShowCount(userId: $userId) {
      id
      noShowCount
    }
  }
`;
